// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Ho-z","badgeLink":"Io-z","category":"Jo-z"};